import i18n from 'src/i18n/index.js';

class PaymentTerm {
  constructor(paymentTerm, discounts, isMutable) {
    this.paymentTerm = paymentTerm;
    this.isMonthly = paymentTerm === 1;
    this.isQuarterly = paymentTerm === 3;
    this.isHalfYearly = paymentTerm === 6;

    this.isYearly = paymentTerm === 12;
    this.translation = i18n.global.t(`paymentTerm.${paymentTerm}`);
    this.termDiscounts = discounts ? new PaymentTermDiscounts(discounts) : undefined;
    this.isMutable = isMutable;
  }

  getDiscount(termInMonths) {
    if (!this.termDiscounts) return undefined;
    if (termInMonths === 1) return this.termDiscounts.monthly;
    if (termInMonths === 3) return this.termDiscounts.quarterly;
    if (termInMonths === 6) return this.termDiscounts.halfYearly;
    if (termInMonths === 12) return this.termDiscounts.yearly;
  }
}

export class PaymentTermDiscounts {
  constructor(discounts) {
    this.yearly = discounts.yearly;
    this.halfYearly = discounts.halfYearly;
    this.quarterly = discounts.quarterly;
    this.monthly = discounts.monthly;
  }
}

export { PaymentTerm as default };
